// src/hooks/useHistory.ts (Fixed)
import { useCallback } from 'react';
import { useLocalStorage } from './useLocalStorage';
import type { HistoryItem } from '@/types/usage';

const MAX_HISTORY_ITEMS = 20;

export const useHistory = () => {
  const [history, setHistory] = useLocalStorage<HistoryItem[]>('userHistory', []);

  const addToHistory = useCallback((input: string, output: string, model?: string, rating: 'thumbs_up' | 'thumbs_down' | 'no_rating' = 'no_rating', id?: string) => {
    const newItem: HistoryItem = {
      id: id || Date.now().toString(),
      input,
      output,
      timestamp: new Date().toLocaleString(),
      model,
      rating
    };

    setHistory(prev => [newItem, ...prev.slice(0, MAX_HISTORY_ITEMS - 1)]);
  }, [setHistory]);

  const clearHistory = useCallback(() => {
    setHistory([]);
  }, [setHistory]);

  const removeHistoryItem = useCallback((id: string) => {
    setHistory(prev => prev.filter(item => item.id !== id));
  }, [setHistory]);

  const updateHistoryRating = useCallback((id: string, rating: 'thumbs_up' | 'thumbs_down' | 'no_rating') => {
    setHistory(prev => prev.map(item => 
      item.id === id ? { ...item, rating } : item
    ));
  }, [setHistory]);

  return {
    history,
    addToHistory,
    clearHistory,
    removeHistoryItem,
    updateHistoryRating
  };
};